import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class QuotationService {
  async fetch(page, perPage, search) {
    const pageParam = `page=${page}&perPage=${perPage}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(
      `/quotations?${params}`
    );
    if (response.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async view(id) {
    const response = await ajaxService.get(`/quotations/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addQuotation(data) {
    const response = await ajaxService.post(`/quotations`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async editQuotation(id, data) {
    const response = await ajaxService.put(`/quotations/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deleteQuotation(id) {
    const response = await ajaxService.delete(`/quotations/`, id);
    if (response ?? false) {
      return response;
    }
  }


  // Rate Sending To Customers API

  async fetchRates(page, perPage, search) {
    const pageParam = `page=${page}&perPage=${perPage}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(
      `/rate-quotations?${params}`
    );
    if (response.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async viewRate(id) {
    const response = await ajaxService.get(`/rate-quotations/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async storeRateSending(data) {
    const response = await ajaxService.post(`/rate-quotations`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async updateRateSending(id, data) {
    const response = await ajaxService.put(`/rate-quotations/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }

  async deleteRate(id) {
    const response = await ajaxService.delete(`/rate-quotations/`, id);
    if (response ?? false) {
      return response;
    }
  }
}

const quotationService = new QuotationService();

export default quotationService;
